import { FEDERATED_GOOGLE_EMAIL_ENTITY_ATI } from '../../../types/entities';
import { type ThirdPartyConfig } from '../../../types/schemas/types';
import { TypeFilterValueKey } from '../../../utils/filters/universalType';
import { get3PLogo } from '../../icons';
import { ProductResourceTypes3P } from '../types';

import { GmailIcon, GmailIconBorderless, GmailSearchResultIcon } from './icon';

export const gmailConfig: ThirdPartyConfig = {
	displayName: 'Gmail',
	id: 'gmail',
	resourceType: ProductResourceTypes3P.Gmail,
	icon: get3PLogo(GmailIcon, 'Gmail', 'medium'),
	iconBorderless: get3PLogo(GmailIconBorderless, 'Gmail', 'small'),
	searchResultIcon: get3PLogo(GmailSearchResultIcon, 'Gmail', 'large'),
	integrationAri: 'ari:cloud:platform::integration/google',
	requiresOauth: true,
	typeFilterConfig: new Map([
		[
			TypeFilterValueKey.Message,
			{
				entities3P: [FEDERATED_GOOGLE_EMAIL_ENTITY_ATI],
				subTypes3P: [],
			},
		],
	]),
	filters: ['lastUpdated'],
	isEnabled: () => true,
	isFederated: true,
};
